import { Ajax } from "./modules/ajax/ajax.js";
import { Dialog } from "./modules/dialog/dialog.js";
import { Toast } from "./modules/dialog/toast.js";
import { Razor } from "./modules/razor/razor.js";
import { ListView } from "./modules/components/list-view.js";
import { FileUploader } from "./modules/io/fileuploader.js";
import { BlurredMenu } from "./modules/components/blurred-menu.js";
import { Browser } from "./modules/core/browser.js";
import { DbInterfacer } from "./modules/database/db-interfacer.js";
import { Card } from "./modules/components/card/card.js";
import { Checkbox } from "./modules/components/checkbox/checkbox.js";
import { Textarea } from "./modules/components/textarea/textarea.js";
import { InfoGroup } from "./modules/components/infogroup/info-group.js";
import { InfoGroupRow } from "./modules/components/infogroup/infogroup-row.js";
import { InfoGroupValue } from "./modules/components/infogroup/infogroup-value.js";
import { Input } from "./modules/components/input/input.js";
import { Dropdown } from "./modules/components/dropdown/dropdown.js";
import { DropdownItem } from "./modules/components/dropdown/dropdown-item.js";
import { Callout } from "./modules/components/callout/callout.js";
import { SortableList } from "./modules/components/sortablelist/sortable-list.js";
import { SortableListItem } from "./modules/components/sortablelist/sortable-listitem.js";
import { Tree } from "./modules/components/tree/tree.js";
import { TreeItem } from "./modules/components/tree/tree-item.js";
import { DropdownDivider } from "./modules/components/dropdown/dropdown-divider.js";
import { DropdownGroup } from "./modules/components/dropdown/dropdown-group.js";
import { DropdownHeader } from "./modules/components/dropdown/dropdown-header.js";
import { MenuItem } from "./modules/components/contextmenu/menu-item.js";
import { ContextMenu } from "./modules/components/contextmenu/context-menu.js";
import { MenuDivider } from "./modules/components/contextmenu/menu-divider.js";
import { Accordion } from "./modules/components/accordion/accordion.js";
import { AccordionItem } from "./modules/components/accordion/accordion-item.js";
import { TabGroup } from "./modules/components/tabs/tabgroup.js";
import { Tab } from "./modules/components/tabs/tab.js";
import { Form } from "./modules/components/form/form.js";
import { FormSection } from "./modules/components/form/form-section.js";
import { Prompt } from "./modules/components/emptyprompt/prompt.js";
import { Button } from "./modules/components/button/button.js";
import { SplitButton } from "./modules/components/button/splitbutton.js";
import { DropdownButton } from "./modules/components/button/dropdown-button.js";
import { IconPicker } from "./modules/components/iconpicker/iconpicker.js";
import { ButtonGroup } from "./modules/components/button/button-group.js";
import { ColourPicker } from "./modules/components/colourpicker/colourpicker.js";
import { Badge } from "./modules/components/badge/badge.js";
import { Label } from "./modules/components/label/label.js";
import { Header } from "./modules/components/header/header.js";
import { Range } from "./modules/components/range/range.js";
import { Breadcrumb } from "./modules/components/breadcrumb/breadcrumb.js";
import { BreadcrumbItem } from "./modules/components/breadcrumb/breadcrumb-item.js";
import { Progress } from "./modules/components/progress/progress.js";
import { ProgressItem } from "./modules/components/progress/progress-item.js";
import { Radio } from "./modules/components/radio/radio.js";
import { CodeBlock } from "./modules/components/code-block/code-block.js";
import { hljs as CodeHighlight } from "./highlight.min.js";
import { Frame } from "./modules/components/wireframe/frame.js";
import { FrameHeader } from "./modules/components/wireframe/frame-header.js";
import { FrameSidebar } from "./modules/components/wireframe/frame-sidebar.js";
import { FrameContent } from "./modules/components/wireframe/frame-content.js";
import { SidebarHeader } from "./modules/components/wireframe/sidebar-header.js";
import { SidebarItem } from "./modules/components/wireframe/sidebar-item.js";
import { Beacon } from "./modules/components/beacon/beacon.js";
import { Icon } from "./modules/components/icon/icon.js";
import { Select } from "./modules/components/select/select.js";
import { ChipOption } from "./modules/components/select/option.js";
import { Carousel } from "./modules/components/carousel/carousel.js";
import { CarouselSlide } from "./modules/components/carousel/carousel-slide.js";
import { Link } from "./modules/components/link/link.js";
import { ConfigReport } from "./modules/reports/config-report.js";
import { DateFormat } from "./modules/components/dateformat/date-format.js";
import { Grid } from "./modules/components/grid/grid.js";
import { ProgressBar } from "./modules/components/progress-bar/progressbar.js";
import { Loading } from "./modules/components/loading/loading.js";
import { List } from "./modules/components/list/list.js";
import { ListItem } from "./modules/components/list/list-item.js";

const localizationHandler = {
	get(target, key) {
		return key in target ? target[key] : key;
	},
	set(target, key, value) {
		return Reflect.set(target, key, value);
	}
};

Object.assign(global, {
	Localizer: new Proxy({}, localizationHandler),
	Ajax, Dialog, Toast, ContextMenu, ListView,
	FileUploader, BlurredMenu, Razor, Browser, DbInterfacer, CodeHighlight
});

Event.prototype.halt = function () {
	this.stopPropagation();
	this.stopImmediatePropagation();
}

HTMLElement.prototype.wrapWithElement = function (nodeName, attributes) {
	const wrapper = Object.assign(document.createElement(nodeName), attributes);
	this.insertAdjacentElement("beforebegin", wrapper);

	wrapper.appendChild(this);
	return wrapper;
}

Document.prototype.createElementWithContents = function (nodeName, content, attributes) {
	const element = Object.assign(this.createElement(nodeName), attributes);

	if (content instanceof NodeList || content instanceof HTMLCollection || Array.isArray(content)) { element.append(...[...content].filter(x => x != null)); }
	else if (content instanceof Node) { element.appendChild(content); }
	else if (content != null) { element.innerHTML = content.toString(); }

	return element;
}

HTMLElement.prototype.toggleClass = function (className, add) {
	if (add == null) {
		add = !this.classList.contains(className);
	}

	if (add) {
		this.classList.add(className);
	} else {
		this.removeClass(className);
	}
}

function replaceURLs(element) {
	const urlRegex = /ht{2}ps?:\/\/(?:w{3}\.|(?!w{3}))[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|w{3}\.[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|ht{2}ps?:\/\/(?:w{3}\.|(?!w{3}))[a-zA-Z\d]+\.\S{2,}|w{3}\.[a-zA-Z\d]+\.\S{2,}/gi;

	function processTextNode(textNode) {
		const text = textNode.nodeValue;
		const fragment = document.createDocumentFragment();
		let lastIndex = 0;

		text.replace(urlRegex, (url, offset) => {
			const displayURL = url;

			if (url.toLowerCase().startsWith("www.")) {
				url = "//" + url;
			}

			if (lastIndex < offset) {
				fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
			}

			fragment.appendChild(document.createElementWithContents("chip-link", displayURL, {
				rel: "noopener",
				target: "_blank",
				href: url
			}));

			lastIndex = offset + displayURL.length;
		});

		if (lastIndex < text.length) {
			fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
		}

		textNode.replaceWith(fragment);
	}

	function traverseNodes(node) {
		if (node.nodeType === Node.TEXT_NODE) {
			processTextNode(node);
		} else if (node.nodeType === Node.ELEMENT_NODE) {
			Array.from(node.childNodes).forEach(traverseNodes);
		}
	}

	traverseNodes(element);
}

function replaceEmails(element) {
	const emailRegex = /[a-z\d!#$%&'*/=?^_`{|}~-]+(?:\.[a-z\d!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z\d](?:[a-z\d-]*[a-z\d])?/ig;

	function processTextNode(textNode) {
		const text = textNode.nodeValue;
		const fragment = document.createDocumentFragment();
		let lastIndex = 0;

		text.replace(emailRegex, (email, offset) => {
			if (lastIndex < offset) {
				fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
			}

			fragment.appendChild(document.createElementWithContents("chip-link", email, {
				href: `mailto:${email}`
			}));

			lastIndex = offset + email.length;
		});

		if (lastIndex < text.length) {
			fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
		}

		textNode.replaceWith(fragment);
	}

	function traverseNodes(node) {
		if (node.nodeType === Node.TEXT_NODE) {
			processTextNode(node);
		} else if (node.nodeType === Node.ELEMENT_NODE) {
			Array.from(node.childNodes).forEach(traverseNodes);
		}
	}

	traverseNodes(element);
}

HTMLElement.prototype.enhance = function () {
	replaceURLs(this);
	replaceEmails(this);
}

function trimBreaksFromElement(element) {
	let lines = element.textContent.split('\n');

	if (lines.at(0) === "") { lines.shift(); }

	let matches,
		indentation = (matches = /^\s+/.exec(lines[0])) !== null ? matches[0] : null;

	if (indentation) {
		lines = lines.map(line => line.replace(indentation, '').replace(/\t/g, '    '));
		element.textContent = lines.join('\n').trimStart();

		if (!element.nextSibling) { element.textContent = element.textContent.trimEnd(); }
	}
}

HTMLElement.prototype.trimBreaks = function () {
	trimBreaksFromElement(this);
}

Node.prototype.trimBreaks = function () {
	trimBreaksFromElement(this);
}

HTMLElement.prototype.removeClasses = function (...classNames) {
	this.classList.remove(classNames);

	if (this.className === "") {
		this.removeAttribute("class");
	}
}

HTMLElement.prototype.removeClass = function (className) {
	this.removeClasses(className);
}

function similarity(s1, s2) {
	let longer = s1;
	let shorter = s2;

	if (s1.length < s2.length) {
		longer = s2;
		shorter = s1;
	}

	const longerLength = longer.length;

	if (longerLength == 0) {
		return 1.0;
	}
	return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

function editDistance(s1, s2) {
	s1 = s1.toLowerCase();
	s2 = s2.toLowerCase();

	const costs = [];

	for (let i = 0; i <= s1.length; i++) {
		let lastValue = i;

		for (let j = 0; j <= s2.length; j++) {
			if (i == 0) {
				costs[j] = j;
			}
			else if (j > 0) {
				let newValue = costs[j - 1];

				if (s1.charAt(i - 1) != s2.charAt(j - 1)) {
					newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
				}

				costs[j - 1] = lastValue;
				lastValue = newValue;
			}
		}

		if (i > 0) {
			costs[s2.length] = lastValue;
		}
	}

	return costs[s2.length];
}

// Functions

const isScrollable = node => {
	if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
		return false
	}
	const style = getComputedStyle(node)
	return ['overflow', 'overflow-x', 'overflow-y'].some((propertyName) => {
		const value = style.getPropertyValue(propertyName)
		return value === 'auto' || value === 'scroll'
	})
}

global.IsURL = function (value) {
	return /ht{2}ps?:\/\/(?:w{3}\.|(?!w{3}))[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|w{3}\.[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|ht{2}ps?:\/\/(?:w{3}\.|(?!w{3}))[a-zA-Z\d]+\.\S{2,}|w{3}\.[a-zA-Z\d]+\.\S{2,}/i.test(value.trim());
}

global._setFlavourLocalization = function (flavour = "default") {
	flavour ||= "default";

	if (flavour === "default") {
		Object.assign(Localizer, {
			ERROR_TITLE: "Error",
			ERROR_MESSAGE: "Something went wrong, and we're not sure what it was. You can either try again or report this error to an administrator if it persists."
		});
	} else {
		Object.assign(Localizer, {
			ERROR_TITLE: "There was a problem",
			ERROR_MESSAGE: "An unknown error has caused the application to stop working. If you continue to see this error, contact us."
		});
	}

	Localizer.DIALOG_BUTTON_CLOSE = "Close";
	Localizer.DIALOG_BUTTON_AFFIRMATIVE = "Yes";
	Localizer.DIALOG_BUTTON_NEGATIVE = "No";

	Localizer.THEME_BUTTON_DARK = "Change to light mode";
	Localizer.THEME_BUTTON_LIGHT = "Change to dark mode";
	Localizer.TOGGLE_DROPDOWN = "Toggle dropdown";

	Localizer.CONFIRMATION_TITLE = "Are you sure?";
	Localizer.WARNING_TITLE = "Warning";
	Localizer.SUCCESS_TITLE = "Success";

	Localizer.DROPDOWN_REQUIRED = "Please select an option";
	Localizer.COPIED_VALUE = "Copied to clipboard successfully";
	Localizer.TOGGLE_SIDEBAR = "Toggle sidebar";

	Localizer.BAD_REQUEST = "Something about your request wasn't recognized. Please try again later, and report this issue to an administrator if it persists.";
	Localizer.NOT_FOUND = "We couldn't seem to find the resource you requested. It could be that it doesn't exist, or it has been deleted.";
	Localizer.ACCESS_DENIED = "It doesn't look like you've got permission to do that. If you believe this is a mistake, please contact your system administrator.";
	Localizer.ACCESS_DENIED_TITLE = "Access Denied";

	Object.assign(Dialog.DefaultOptions, {
		ButtonText: Localizer.DIALOG_BUTTON_CLOSE,
		AffirmativeText: Localizer.DIALOG_BUTTON_AFFIRMATIVE,
		NegativeText: Localizer.DIALOG_BUTTON_NEGATIVE
	});
}

global.getScrollParent = node => {
	let currentParent = node.parentElement
	while (currentParent) {
		if (isScrollable(currentParent)) {
			return currentParent
		}
		currentParent = currentParent.parentElement
	}
	return document.scrollingElement || document.documentElement
}

global.getClipboardText = async function () {
	try {
		const state = (await navigator.permissions.query({ name: 'clipboard-read' })).state;

		return state !== "denied"
			? await navigator.clipboard.readText()
			: "";
	} catch {
		// Firefox doesn't support reading from the clipboard
		return "";
	}
}

global.getClipboardData = async function () {
	try {
		const state = (await navigator.permissions.query({ name: 'clipboard-read' })).state;

		return state !== "denied"
			? await navigator.clipboard.read()
			: [];
	} catch {
		// Firefox being Firefox
		return [];
	}
}

global.writeClipboardText = async function (text) {
	try {
		const state = (await navigator.permissions.query({ name: 'clipboard-write' })).state;

		if (state !== "denied") {
			await navigator.clipboard.writeText(text);
		}
	} catch {
		await navigator.clipboard.writeText(text);
	}
}

global.writeClipboard = async function (items) {
	try {
		const state = (await navigator.permissions.query({ name: 'clipboard-write' })).state;

		if (state !== "denied") {
			await navigator.clipboard.write(items);
		}
	} catch {
		await navigator.clipboard.write(items);
	}
}

global.capitalise = function (str) {
	return String(str).charAt(0).toUpperCase() + String(str).slice(1);
}

global.toTitleCase = function (str) {
	if (!str) { return str; }

	let upper = true;
	let newStr = "";

	for (let i = 0, l = str.length; i < l; i++) {
		if (str[i] == " ") {
			upper = true;
			newStr += str[i];

			continue;
		}

		newStr += upper ? str[i].toUpperCase() : str[i].toLowerCase();
		upper = false;
	}

	return newStr;
}

global.SortCaseInsensitive = function (a, b) {
	return a.toLowerCase().localeCompare(b.toLowerCase());
}

global.GroupBy = (array, fn) => array.reduce((a, b, i) => {
	const key = fn(b, i, array);

	a[key] ||= [];
	a[key].push(b);

	return a;
}, {});

global.SearchArray = function (array, query, propertyName, minLength) {
	const splitQuery = query.toUpperCase().split(" "),
		matchWholeProp = query.length < minLength;

	let arrSearched = array.
		map(x => {
			const comparator = propertyName ? x[propertyName] : x;

			const obj = {
				IsMatch: false,
				OriginalElement: x,
				MatchLevel: similarity(comparator.toUpperCase(), query)
			}

			if (matchWholeProp) {
				obj.IsMatch = comparator.toUpperCase() === query.toUpperCase();
			} else {
				obj.IsMatch = splitQuery.find(y => comparator.toUpperCase().includes(y));
			}

			return obj;
		}).filter(x => x.IsMatch).sort((a, b) => b.MatchLevel - a.MatchLevel);

	// If we're doing a fuzzy search, and there are results that contain ALL queries, reduce the fuzzy search to these results
	if (!matchWholeProp && splitQuery.length > 1) {
		const verboseMatches = arrSearched.filter(x => {
			const originalComparator = propertyName ? x.OriginalElement[propertyName] : x.OriginalElement;

			return !splitQuery.find(y => !originalComparator.toUpperCase().includes(y))
		});

		if (verboseMatches.length) {
			arrSearched = verboseMatches;
		}
	}

	return arrSearched.map(x => x.OriginalElement);
}

_setFlavourLocalization(document.documentElement.dataset.flavour);

window.customElements.define("chip-card", Card);
window.customElements.define("chip-checkbox", Checkbox);
window.customElements.define("chip-input", Input);
window.customElements.define("chip-textarea", Textarea);
window.customElements.define("chip-infogroup", InfoGroup);
window.customElements.define("chip-inforow", InfoGroupRow);
window.customElements.define("chip-infovalue", InfoGroupValue);
window.customElements.define("chip-dropdown", Dropdown);
window.customElements.define("chip-dropdownitem", DropdownItem);
window.customElements.define("chip-dropdowndivider", DropdownDivider);
window.customElements.define("chip-dropdowngroup", DropdownGroup);
window.customElements.define("chip-dropdownheader", DropdownHeader);
window.customElements.define("chip-callout", Callout);
window.customElements.define("chip-sortablelist", SortableList);
window.customElements.define("chip-sortablelistitem", SortableListItem);
window.customElements.define("chip-tree", Tree);
window.customElements.define("chip-treeitem", TreeItem);
window.customElements.define("chip-contextmenu", ContextMenu);
window.customElements.define("chip-menuitem", MenuItem);
window.customElements.define("chip-menudivider", MenuDivider);
window.customElements.define("chip-accordion", Accordion);
window.customElements.define("chip-accordionitem", AccordionItem);
window.customElements.define("chip-button", Button);
window.customElements.define("chip-splitbutton", SplitButton);
window.customElements.define("chip-dropdownbutton", DropdownButton);
window.customElements.define("chip-tabgroup", TabGroup);
window.customElements.define("chip-tab", Tab);
window.customElements.define("chip-form", Form);
window.customElements.define("chip-formsection", FormSection);
window.customElements.define("chip-emptyprompt", Prompt);
window.customElements.define("chip-iconpicker", IconPicker);
window.customElements.define("chip-buttongroup", ButtonGroup);
window.customElements.define("chip-colourpicker", ColourPicker);
window.customElements.define("chip-badge", Badge);
window.customElements.define("chip-label", Label);
window.customElements.define("chip-header", Header);
window.customElements.define("chip-range", Range);
window.customElements.define("chip-breadcrumb", Breadcrumb);
window.customElements.define("chip-breadcrumbitem", BreadcrumbItem);
window.customElements.define("chip-progress", Progress);
window.customElements.define("chip-progressitem", ProgressItem);
window.customElements.define("chip-radio", Radio);
window.customElements.define("chip-codeblock", CodeBlock);
window.customElements.define("chip-frame", Frame);
window.customElements.define("chip-frameheader", FrameHeader);
window.customElements.define("chip-framesidebar", FrameSidebar);
window.customElements.define("chip-framecontent", FrameContent);
window.customElements.define("chip-sidebarheader", SidebarHeader);
window.customElements.define("chip-sidebaritem", SidebarItem);
window.customElements.define("chip-beacon", Beacon);
window.customElements.define("chip-icon", Icon);
window.customElements.define("chip-select", Select);
window.customElements.define("chip-option", ChipOption);
window.customElements.define("chip-carousel", Carousel);
window.customElements.define("chip-carouselslide", CarouselSlide);
window.customElements.define("chip-link", Link);
window.customElements.define("chip-dateformat", DateFormat);
window.customElements.define("chip-grid", Grid);
window.customElements.define("chip-progressbar", ProgressBar);
window.customElements.define("chip-loading", Loading);
window.customElements.define("chip-list", List);
window.customElements.define("chip-listitem", ListItem);

if (location.hash) {
	const closestTab = document.getElementById(location.hash.substring(1))?.closest(".tab-group__tab, chip-tab");

	if (closestTab) {
		closestTab.closest("chip-tabgroup").selectIndex([...closestTab.parentElement.children ?? []].indexOf(closestTab));
	}
}

Razor.UpdateState();

function closeDropdownsFromEvent(ev) {
	let closestInput = ev.target?.closest?.("chip-dropdown")?.parentElement;

	if (closestInput?.nodeName !== "CHIP-INPUT") { closestInput = null; }

	[...document.querySelectorAll("chip-dropdown")].filter(x => (ev.target instanceof Node && !x.contains(ev.target)) && x !== ev.target?.closest?.("chip-dropdown") && !closestInput?.contains(x))
		.forEach(x => x.Close());
}

window.addEventListener('focus', ev => closeDropdownsFromEvent(ev), false);

document.body.addEventListener("mousedown", ev => {
	document.querySelectorAll("chip-contextmenu").forEach(x => x.HandleMenuBlurEvent(ev));

	closeDropdownsFromEvent(ev);
});

if (document.documentElement.dataset.testMode?.toLowerCase() === "true") {
	window.addEventListener("load", () => ConfigReport.Run());
} else if (!document.documentElement.hasAttribute("data-test-mode")) {
	console.warn("Missing test-mode dataset tag on html element");
}